import { types, actions } from './requests'
export const CREATEMAPPING_TYPES = {
    ...types('CREATEMAPPING'),
}
export const CREATEMAPPING_ACTIONS = {
    ...actions('CREATEMAPPING'),
}
